import React from "react";
import styles from "./EventSummary.module.scss";
import { useAppSelector } from "@src/store/hooks";
import { DateFormatsEnum, formatDate } from "../utils/dateUtils";
import helperStyles from "@src/components/helpers.module.scss";
import { clx } from "../utils/stringUtils";
import { MyTooltip } from "../tooltip/Tooltip";

type TEventSummary = {
	hasEllipsis?: boolean;
} & React.ComponentProps<"div">;

const EventSummary: React.FC<TEventSummary> = ({ hasEllipsis = true, ...rest }) => {
	const event = useAppSelector((state) => state.pricing.selection.event);
	if (!event) return <div className={styles.root}>Event not selected</div>;

	const formattedEventDate = formatDate(event.Event_Date, DateFormatsEnum["MM/DD/YYYY"]);
	const fullEventSummary = `${event.Event_Name} - ${event.Venue_Name} - ${formattedEventDate} @ ${event.Event_Time}`;
	const { style, ...restDestructured } = rest;

	return (
		<div style={{ display: "flex", minWidth: 0 }}>
			<MyTooltip
				id={`eventSummaryTooltip`}
				popupStyle={{ fontSize: "1rem", fontWeight: 600 }}
				popup={fullEventSummary}
				elementStyle={style}
				element={
					<div className={clx({ [styles.root]: true, [helperStyles.ellipsisDiv]: hasEllipsis })} {...restDestructured}>
						{fullEventSummary}
					</div>
				}
			/>
		</div>
	);
};

export default EventSummary;
